import React from "react";
import "./Card.css";
import { useNavigate } from "react-router-dom";
import truncateText from "../../../utils/truncateText";
import ImageWithSkeleton from "../ImageWithSkeleton/ImageWithSkeleton";

const Card = ({ item }) => {


  const navigate = useNavigate()

  const handleNavigate=()=>{
  navigate(`/pd/${item.id}`)

  }


  return (
    <div className="card" onClick={handleNavigate} style={{width:'unset',cursor:'pointer'}}>
      {/* <img src={`${item.imageUrl}`} alt={item.title} className="card__image" style={{maxWidth:511}} /> */}
      <ImageWithSkeleton src={`${item.imageUrl}`} alt={item.name} className="card__image" style={{maxWidth:311,aspectRatio:1,objectFit:'cover'}} />
      <h3 className="card__title" style={{fontSize:13,fontWeight:'400',maxWidth:311,minHeight:51}} >{truncateText(item.name,55)}</h3>
      <p className="card__price" style={{maxWidth:311,margin:'0'}}>

         <span className="card__new-price" style={{color:'rgb(0, 98, 11)',fontSize:17,marginRight:5}}>₹ {item.discountedPrice}</span>  <span className="card__old-price">₹ {item.price}</span> <span className="card__currency"></span>

      </p>
    </div>
  );
};

export default Card;
